// extracted by mini-css-extract-plugin
export default {"root":"ConfigManage_root__mUYn9"};